let ManagedState = {};

export const savestate = (key, state) => {
  ManagedState = { ...ManagedState, [key]: state };
};

export const getstate = (key) => {
  if (ManagedState && ManagedState[key]) {
    return ManagedState[key];
  }
  return null;
};
